"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var styles = _interopRequireWildcard(require("./StoryLogo.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function degToRad(deg) {
  return deg * Math.PI / 180;
}

const dotWrapperSize = 12;

const StoryLogo = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    img,
    variant,
    title,
    subtitle,
    size = 32,
    ...otherProps
  } = props;
  const angleRad = degToRad(-50);
  const radius = size / 2; // Calculate symbol position
  // Subtract half of symbol size to center it on the circle

  const x = radius * Math.cos(angleRad) + radius - dotWrapperSize / 2;
  const y = radius * Math.sin(angleRad) + radius - dotWrapperSize / 2;
  return (0, _pragma.createFelaElement)(_.View, _extends({
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    ref: ref
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    css: styles.storyLogo,
    cssProps: {
      variant,
      size
    }
  }, (0, _pragma.createFelaElement)("img", {
    src: img,
    alt: "Channel"
  }), variant === 'pulsing' && (0, _pragma.createFelaElement)(_.View, {
    css: styles.dotWrapper,
    cssProps: {
      left: x,
      top: y
    }
  }, (0, _pragma.createFelaElement)(_.View, {
    css: styles.dot
  }), (0, _pragma.createFelaElement)(_.View, {
    css: styles.dotBg,
    cssProps: {
      size: dotWrapperSize
    }
  }))), title && (0, _pragma.createFelaElement)(_.Text, {
    size: "xs",
    weight: "semiBold",
    align: "center",
    lineHeight: "xl"
  }, title), subtitle && (0, _pragma.createFelaElement)(_.Text, {
    size: "xs",
    color: "text.2",
    align: "center",
    lineHeight: "xl"
  }, subtitle));
});

StoryLogo.displayName = 'StoryLogo';
var _default = StoryLogo;
exports.default = _default;
//# sourceMappingURL=StoryLogo.js.map